/**
 * Badge shown on dropdown items that match the selected vendor's profile services.
 */
export default function SuggestedChip({ className = "" }) {
  return (
    <span
      className={`ml-1.5 inline-flex items-center rounded-md bg-indigo-50 px-1.5 py-0.5 text-[10px] font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/20 ${className}`}
      title="Listed on this vendor's profile"
    >
      Suggested
    </span>
  );
}
